import dynamic from "next/dynamic"

import type { NewsletterBannerProps } from "./NewsletterBanner"

const DynamicNewsletterBanner = dynamic<NewsletterBannerProps>(() => import("./NewsletterBanner"), {
  ssr: false,
})

export default DynamicNewsletterBanner
